module.exports = __webpack_public_path__ + "static/media/blowingsnow-icon.cf6b8395.svg";